export default "__VITE_ASSET__BI3QvZxB__"